import classNames from "classnames";
import { decamelizeKeys } from "humps";
import PageBox from "PFComponents/box/page_box";
import { LoadingDots } from "PFComponents/loading_dots";
import { Typography } from "PFComponents/typography";
import { useFiltersConfig } from "PFCore/hooks/queries/saas_admin/filters_config/use_filters_config";
import { Account } from "PFTypes/account";
import { FiltersConfig, FiltersConfigTemplate } from "PFTypes/filters_config";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./filters_config_page.module.scss";
import { useFiltersConfigFormSubmit } from "./hooks/use_filters_config_form_submit";
import { FilterConfigSearch } from "./parts/filter_config_search";
import { FiltersConfigForm } from "./parts/filters_config_form";

type FiltersConfigPageProps = {
  account: Account;
  filtersConfigTemplate: FiltersConfigTemplate;
};

export const FiltersConfigPage = ({ account, filtersConfigTemplate }: FiltersConfigPageProps) => {
  const { t } = useTranslation("saasAdmin");

  const [target, setTarget] = useState<string | null>(null);

  const { data: filtersConfig, isFetched: isFiltersConfigDataFetched } = useFiltersConfig(
    account.id,
    target || "",
    { enabled: !!target }
  );

  const { handleSubmit, handleError, isLoading: isUpdating } = useFiltersConfigFormSubmit(account.id, target);

  const handleSelect = (selectedOptionId: string) => {
    setTarget(selectedOptionId);
  };

  return (
    <div>
      <header className={css.header}>
        <Typography variant="h1">{t("filtersConfig.title")}</Typography>
        <Typography variant="h4" className={css.subheader}>
          {`(${account.name})`}
        </Typography>
      </header>
      <PageBox className={classNames(css.pageBox, { [css.updating]: isUpdating })}>
        <FilterConfigSearch template={filtersConfigTemplate} selected={target} onSelect={handleSelect} />
        {!!target &&
          (filtersConfig && isFiltersConfigDataFetched ? (
            <FiltersConfigForm
              key={target}
              target={target}
              filtersConfig={decamelizeKeys(filtersConfig) as FiltersConfig}
              filtersConfigTemplate={decamelizeKeys(filtersConfigTemplate) as FiltersConfigTemplate}
              onSubmit={handleSubmit}
              onError={handleError}
            />
          ) : (
            <LoadingDots circlesEnabled pageViewEnabled />
          ))}
      </PageBox>
    </div>
  );
};
